import { render, staticRenderFns } from "./AddressPage.vue?vue&type=template&id=644daede&"
import script from "./AddressPage.vue?vue&type=script&lang=js&"
export * from "./AddressPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports